import {controller} from '@github/catalyst'
import {cookieExpiration} from './helpers'
import {getCookie, setCookie} from '@github-ui/cookies'

@controller
class GlobalBannerElement extends HTMLElement {
  connectedCallback() {
    if (this.hidden) return
    const disabledBanners = getCookie('disabled_global_site_banners')?.value.split(',') || []
    if (disabledBanners.includes(this.id)) this.hidden = true

    this.initializeCountdown() // Initialize site_universe_25_1_global_banner countdown
  }

  // Countdown for Universe 2025
  // Remove with site_universe_25_1_global_banner feature flag cleanup
  protected countdownInterval: number | null = null
  protected readonly targetDate = new Date('2025-09-18T08:00:00Z') // PST is UTC-8, so midnight PST = 8:00 UTC

  disconnectedCallback() {
    this.clearCountdownInterval()
  }

  protected initializeCountdown() {
    const countdownElement = this.querySelector('.js-global-banner-countdown') as HTMLElement
    const numberElement = this.querySelector('.js-global-banner-countdown-number') as HTMLElement

    if (!countdownElement || !numberElement) return

    // Check if countdown should be shown
    const now = new Date()
    if (now >= this.targetDate) {
      countdownElement.style.display = 'none'
      return
    }

    // Show countdown and start timer
    countdownElement.style.display = 'inline-block'
    this.updateCountdownDisplay(numberElement)

    this.countdownInterval = window.setInterval(() => {
      this.updateCountdownDisplay(numberElement)
    }, 1000)
  }

  protected updateCountdownDisplay(numberElement: HTMLElement) {
    const now = new Date()
    const timeRemaining = this.targetDate.getTime() - now.getTime()

    if (timeRemaining <= 0) {
      numberElement.textContent = '00:00:00:00'
      this.clearCountdownInterval()
      const countdownElement = this.querySelector('.js-global-banner-countdown') as HTMLElement
      if (countdownElement) {
        countdownElement.style.display = 'none'
      }
      return
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

    const formattedTime = `${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    numberElement.textContent = formattedTime
  }

  protected clearCountdownInterval() {
    if (this.countdownInterval !== null) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
  }

  // End of countdown code ----------------

  close() {
    this.hidden = true
    this.clearCountdownInterval() // Clear site_universe_25_1_global_banner countdown
    this.updateCookie()
    document.dispatchEvent(new CustomEvent('global-banner:close'))
  }

  updateCookie(cookieName: string = 'disabled_global_site_banners', cookieExpirationDays: number = 30) {
    const existingCookie = getCookie(cookieName)?.value
    if (existingCookie) {
      const cookieValue = existingCookie
        .split(',')
        .filter(id => id !== this.id)
        .join(',')
      setCookie(cookieName, `${cookieValue},${this.id}`, cookieExpiration(cookieExpirationDays))
      return
    }
    setCookie(cookieName, this.id, cookieExpiration(cookieExpirationDays))
  }
}
